import { useTranslation } from 'react-i18next';
import DashboardCommonMonitering from 'pages/monitoring/dashboard/dashboard-common';
import DashboardICPAMonitering from "pages/monitoring/dashboard/dashboard-icpa";
import DashboardChinaMonitering from "pages/monitoring/dashboard/dashboard-china";
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import DashboardNantongMonitering from 'pages/monitoring/dashboard/dashboard-nantong';
import { getDashboardCountByZoneAndEquipmentStatus } from 'components/axios/dashboardAxios';
import DashboardYihaiChinaMonitering from 'pages/monitoring/dashboard/dashboard-yihai';

const DashboardSwitcher = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  const platformServer = process.env.REACT_APP_PLATFORM_SERVER;
  const isChina = process.env.REACT_APP_TIMEZONE === 'Asia/Shanghai';
  // const appLanguage = process.env.REACT_APP_LANGUAGE;
  // const developType = process.env.REACT_APP_DEVELOP_TYPE;

  // const isChina =
  //   developType === 'DEVELOPMENT'
  //     ? i18n.language === 'zh-CN'
  //     : appLanguage === 'zh-CN';
    
  useEffect(() => {
    if (isChina && platformServer !== 'NANTONG' && platformServer !== 'YIHAI') {
      const fetchZones = async () => {
        const res = await getDashboardCountByZoneAndEquipmentStatus();
        // console.log(res)
        const list = Array.isArray(res)
          ? res
          : [];
        // console.log(list)
        if (!list.length) {
          console.warn("none zone info");
          return;
        }
        const zId = list[0]?.id;
        // console.log(zId)
        if (!zId) return;
        navigate(`/dashboard/sub?zId=${zId}`, { replace: true });
      }
      fetchZones();
    }
  }, [isChina, navigate]);

  if (platformServer === 'NANTONG') {
      return <DashboardNantongMonitering />;
  } else if (platformServer === 'YIHAI') {
      return <DashboardYihaiChinaMonitering />;
  }

  if (isChina) {
    return null;
  }

  // 중국버전도 메인 대시보드 사용할 경우
  // if (isChina) {
  //   return <DashboardChinaMonitering />;
  // }

  if (platformServer === 'ICPA') {
      return <DashboardICPAMonitering />;
  }

  return <DashboardCommonMonitering />;
};

export default DashboardSwitcher;